import { createSlice, PayloadAction } from '@reduxjs/toolkit';

const notificationsSlice = createSlice({
  name: 'notifications',
  initialState: {
    isOpen: false,
  },
  reducers: {
    setNotificationsOpen(state, { payload }: PayloadAction<boolean>) {
      state.isOpen = payload;
    },
    openNotificationsPanel(state, _: PayloadAction) {
      state.isOpen = true;
    },
    closeNotificationsPanel(state, _: PayloadAction) {
      state.isOpen = false;
    },
    toggleNotificationsPanel(state, _: PayloadAction) {
      state.isOpen = !state.isOpen;
    },
  },
});

export const {
  setNotificationsOpen,
  openNotificationsPanel,
  closeNotificationsPanel,
  toggleNotificationsPanel,
} = notificationsSlice.actions;

export default notificationsSlice.reducer;
